import React from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const WelcomeHero = () => {
  return (
    <div className="space-y-6">
      {/* Hero Image */}
      <div className="relative overflow-hidden rounded-2xl h-64 sm:h-80">
        <Image
          src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
          alt="Peaceful wellness and mental health support"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <div className="absolute bottom-6 left-6 right-6">
          <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="Heart" size={20} color="var(--color-primary)" />
              <span className="text-sm font-medium text-primary">Wellness Assessment</span>
            </div>
            <p className="text-sm text-text-secondary">
              Understanding your mental health during challenging times
            </p>
          </div>
        </div>
      </div>

      {/* Welcome Content */}
      <div className="space-y-4">
        <div>
          <h1 className="text-3xl sm:text-4xl font-heading font-semibold text-text-primary mb-3">
            Welcome to Your Wellness Journey
          </h1>
          <p className="text-lg text-text-secondary leading-relaxed">
            Take a comprehensive assessment to understand your mental health and overall wellness.
          </p>
        </div>

        <div className="bg-secondary-50 border border-secondary-100 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0 w-8 h-8 bg-secondary-100 rounded-full flex items-center justify-center mt-0.5">
              <Icon name="CheckCircle" size={16} color="var(--color-secondary)" />
            </div>
            <div>
              <h3 className="font-medium text-secondary-700 mb-1">
                Evidence-Based Assessment
              </h3>
              <p className="text-sm text-secondary-600">
                Our assessment uses validated screening tools developed with mental health professionals to provide accurate insights into your wellness.
              </p>
            </div>
          </div>
        </div>

        {/* Key Benefits Preview */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="flex items-center space-x-3 p-3 bg-surface border border-border rounded-lg">
            <Icon name="Clock" size={20} color="var(--color-primary)" />
            <div>
              <p className="font-medium text-text-primary text-sm">5-10 Minutes</p>
              <p className="text-xs text-text-secondary">Quick completion</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3 p-3 bg-surface border border-border rounded-lg">
            <Icon name="Shield" size={20} color="var(--color-secondary)" />
            <div>
              <p className="font-medium text-text-primary text-sm">100% Private</p>
              <p className="text-xs text-text-secondary">Secure & confidential</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHero;